'use strict';

import Cookies from 'js-cookie';



$(document).ready(function() {
  /**
   * Check cookies on load
   */
  // Get page list
  var pagesToExport = getExportList();
  $(pagesToExport).each(function(i,e) {
    $('.add-to-print[data-id='+e.id+']').addClass('checked');
  })
  // Update UI
  exportSummary();


  /**
   * Add page
   */
  function addPage(pageData) {
    // Get page list
    var pagesToExport = getExportList();

    // Don't add duplicates
    if(pagesToExport.find((e) => e.id === pageData.id)) return;

    // Add page
    pagesToExport.push(pageData);

    // Save cookie
    Cookies.set('exportList', pagesToExport, { expires: 30 });

    // Update UI
    exportSummary();
  }

  /**
   * Remove page
   */
  function removePage(pageData) {
    // Get page list
    var pagesToExport = getExportList();

    // Remove page
    var index = pagesToExport.findIndex(function(o){
        return o.id === pageData.id;
    })
    if (index !== -1) pagesToExport.splice(index, 1);

    // Save cookie
    Cookies.set('exportList', pagesToExport, { expires: 30 });

    // Update UI
    exportSummary();
  }

  function clearAllPages() {
    Cookies.remove('exportList');
  }


  /**
   * Returns export list
   */
  function getExportList() {
    var pagesToExport = Cookies.get('exportList');
    if (pagesToExport) {
      return JSON.parse(pagesToExport);
    }
    return pagesToExport = [];
  }


  /**
   * Selected export bar
   */
  function exportSummary() {
    // Get page list
    var pagesToExport = getExportList();

    // Show/hide
    if (pagesToExport.length) {
      // Show & update summary bar
      $('#exportSummary').addClass('visible');
      $('#exportSummary .count').text(pagesToExport.length);
    }
    else {
      // Hide summary bar
      $('#exportSummary').removeClass('visible');
    }
    renderListView();
  }


  /**
   * Update/Render List View
   */
  function renderListView() {
    // Get page list
    var pagesToExport = getExportList();

    // Order list
    pagesToExport.sort(function(a, b) {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    // List HTML
    $('#exportSummary .list-items').html('');
    $(pagesToExport).each(function(i, e) {
      $('#exportSummary .list-items').append(`
        <div class="row print-item">
          <div class="col" style="max-width:64px">
            <div class="mt-2 mt-md-0 icon icon__highlighted icon__${e.type} ir" title="${e.type}">${e.type}</div>
          </div>
          <div class="col">
            <h4 class="d-md-inline-block"><a href="${e.url}">${e.title}</a></h4>
            <button type="button" class="float-md-right mt-md-2 mb-2 btn btn-sm btn-outline-dark remove-page" data-id="${e.id}">${window.lang.REMOVE}</button>
          </div>
        </div>
      `);
    });

    // Close panel if empty
    if (pagesToExport.length === 0 && $('#exportSummary').hasClass('expanded')) {
      $('#exportSummary').removeClass('expanded');
    }
  }


  /**
   * Export PDFs button
   */
  $("body").on("click",".downloadPDF",function(e) {
    e.preventDefault();

    // Get selected list
    if ($(this).data("download")) {
      downloadPDF(String($(this).data("download")).split(','));
    }
    else {
      // Get page list
      var pagesToExport = getExportList();
      // Send to download
      downloadPDF(pagesToExport.map((d)=>d.id));
    }
  });


  /**
   * Download PDF of selected pages.
   *
   * @param {Array} selection
   */
  function downloadPDF(selection) {
    // Lock all download buttons
    $('.downloadPDF').addClass('generating').attr('disabled', 'disabled');

    // Check data
    if (selection instanceof Array === false || selection.length < 1) {
      alert(window.lang.ERR_NOTHING_TO_EXPORT);
      return;
    }

    // Genrate and download
    window.open('/export?list=' + selection.join(','));

    // Reenable download buttons
    $('.downloadPDF').removeClass('generating').attr('disabled', false);
    $('.deselect').trigger('click');
  }


  /**
   * Actions & Events
   */
  // Deselect all
  $("body").on("click", ".deselect", function(e) {
    e.preventDefault();

    // Remove selection
    clearAllPages();
    $('.add-to-print.checked').removeClass('checked');
    $('.add-bundle-to-queue.checked').removeClass('checked');

    // Update export summary
    exportSummary();
  });

  // Add/Remove pages
  $("body").on("click",".add-to-print",function(e) {
    e.preventDefault();

    if ($(this).hasClass('checked')) {
      // Remove page
      $(this).removeClass('checked');
      $('.add-to-print[data-id=' + $(this).data('id') + ']').removeClass('checked');
      removePage($(this).data());
    }
    else {
      // Add page
      $(this).addClass('checked');
      $('.add-to-print[data-id=' + $(this).data('id') + ']').addClass('checked');
      addPage($(this).data());
    }
  });

  // Remove page
  $("body").on("click",".remove-page",function(e) {
    e.preventDefault();
    removePage($(this).data());
    $('.add-to-print[data-id=' + $(this).data('id') + ']').removeClass('checked');
  });

  // Add bundles to queue
  $("body").on("click",".add-bundle-to-queue",function(e) {
    e.preventDefault();
    $(this).addClass('checked');

    const pages = $(this).data('queue-bundle');
    for (let i = 0; i < pages.length; i++) {
      addPage(pages[i]);
    }
  });


  // Toggle download panel
  $("body").on("click","#exportSummary .toggleDownloadPanel",function(e) {
    e.preventDefault();

    $('#exportSummary').toggleClass('expanded');
  });
});
